export default __webpack_public_path__ + "static/media/map.8c08d2a2.png";